<fin-loader role="status" [type]="LoaderType.EMBEDDED" [title]="'LOYALTY.enroll.loading'"></fin-loader>
